"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const component_link_1 = require("@patternplate/component-link");
const component_icon_1 = require("@patternplate/component-icon");
const StyledClose = styled_components_1.default(component_link_1.Link) `
  font-size: 0;
  line-height: 0;
`;
const StyledCloseIcon = styled_components_1.default(component_icon_1.Icon) `
  fill: ${props => props.theme.colors.color};
`;
exports.SearchClose = function SearchClose(props) {
    const verb = props.clears ? `Clear` : "Close";
    const query = props.clears ? { search: null } : { "search-enabled": null };
    const symbol = "close";
    return (React.createElement(StyledClose, { query: query, title: `${verb} search ${props.shortcut.toString()}` },
        React.createElement(StyledCloseIcon, { size: "m", symbol: symbol }),
        verb));
};
//# sourceMappingURL=search-close.js.map